export default __webpack_public_path__ + "static/media/naboso.65d493f1.svg";